import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { WebinarSecondaryBarComponent } from '../../WebinarSecondaryBarComponent/WebinarSecondaryBarComponent'
import {
  getIsDraft,
  isProducerSelector,
  isBroadcastLive,
} from '../../../selectors'
import {
  onLiveCountdownZero as onLiveCountdownZeroAction,
  toggleWebinarOverOverlay as toggleWebinarOverOverlayAction,
} from '../../../actions'

const SecondaryBar = ({
  /**
   * Connected properties
   */
  isDraft,
  isProducer,
  schedule,
  webinarEnded,
  isWebinarOverlayVisible,
  isBroadcasting,
  isEndingWebinar,
  isInGearMode,

  /**
   * Connected functions
   */
  onLiveCountdownZero,
  toggleWebinarOverOverlay,
}) => (
  <>
    {!isBroadcasting && !isEndingWebinar && (
      <WebinarSecondaryBarComponent
        isProducer={isProducer}
        isDraft={isDraft}
        schedule={schedule}
        onLiveCountdownZero={onLiveCountdownZero}
        toggleWebinarOverOverlay={toggleWebinarOverOverlay}
        isWebinarOverlayVisible={isWebinarOverlayVisible}
        webinarEnded={webinarEnded}
        hideCollapseButton={isInGearMode}
      />
    )}
  </>
)

SecondaryBar.propTypes = {
  /**
   * Connected properties
   */
  isDraft: PropTypes.bool,
  isProducer: PropTypes.bool,
  schedule: PropTypes.object,
  webinarEnded: PropTypes.bool,
  isWebinarOverlayVisible: PropTypes.bool,
  isBroadcasting: PropTypes.bool,
  isEndingWebinar: PropTypes.bool,
  isInGearMode: PropTypes.bool,

  /**
   * Connected functions
   */
  onLiveCountdownZero: PropTypes.func,
  toggleWebinarOverOverlay: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  isDraft: getIsDraft(state),
  isProducer: isProducerSelector(state),
  schedule: state.webinar.schedule,
  webinarEnded: state.webinar.webinarEnded,
  isWebinarOverlayVisible: state.webinar.isWebinarOverlayVisible,
  isBroadcasting: isBroadcastLive(state),
  isEndingWebinar: state.webinar.isEndingWebinar,
  isInGearMode: state.webinar.isGearMode,
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  onLiveCountdownZero: onLiveCountdownZeroAction,
  toggleWebinarOverOverlay: toggleWebinarOverOverlayAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryBar)
